import adminApi from '@/api/admin';

// initial state
const state = {
  teachers: [],
  currentSchoolCode: null,
};

// getters
const getters = {
  // eslint-disable-next-line arrow-parens
  teachers: (currentState) => currentState.teachers,
  // eslint-disable-next-line arrow-parens
  currentSchoolCode: (currentState) => currentState.currentSchoolCode,
};

// actions
const actions = {
  getTeachers({ dispatch, commit }, schoolCode) {
    dispatch('showLoader');
    adminApi.getTeachers(schoolCode).then((response) => {
      commit('setTeachers', { teachers: response.data });
      dispatch('hideLoader');
    });
  },
  newTeacher({ dispatch }, teacher) {
    return new Promise((resolve, reject) => {
      dispatch('showLoader');
      adminApi.newTeacher(teacher).then(
        (response) => {
          resolve(response);
          dispatch('hideLoader');
        },
        (error) => {
          dispatch('hideLoader');
          reject(error);
        },
      );
    });
  },
  newGuest({ dispatch }, guest) {
    return new Promise((resolve, reject) => {
      dispatch('showLoader');
      adminApi.newGuest(guest).then(
        (response) => {
          resolve(response);
          dispatch('hideLoader');
        },
        (error) => {
          dispatch('hideLoader');
          reject(error);
        },
      );
    });
  },
  getSchoolCode({ dispatch, commit }) {
    dispatch('showLoader');
    adminApi.getSchoolCode().then((response) => {
      commit('setCurrentSchoolCode', response.data);
      dispatch('hideLoader');
    });
  },
  updateSchoolCode({ dispatch }, schoolCode) {
    return new Promise((resolve, reject) => {
      dispatch('showLoader');
      adminApi.updateSchoolCode(schoolCode).then(
        (response) => {
          resolve(response);
          dispatch('hideLoader');
        },
        (error) => {
          dispatch('hideLoader');
          reject(error);
        },
      );
    });
  },
  removeTeacher({ dispatch }, id) {
    return new Promise((resolve, reject) => {
      dispatch('showLoader');
      adminApi.removeTeacher(id).then(
        (response) => {
          dispatch('getTeachers');
          dispatch('hideLoader');
          resolve(response);
        },
        (error) => {
          dispatch('hideLoader');
          reject(error);
        },
      );
    });
  },
};

// mutations
const mutations = {
  setTeachers(currentState, { teachers }) {
    currentState.teachers = teachers;
  },
  setCurrentSchoolCode(currentState, schoolCode) {
    currentState.currentSchoolCode = schoolCode;
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};



// WEBPACK FOOTER //
// ./src/store/modules/admin.js